import React from 'react';
import { Check } from 'lucide-react';

const steps = [
    { number: 1, label: 'Stammdaten' },
    { number: 2, label: 'Logos' },
    { number: 3, label: 'Unterschrift' },
    { number: 4, label: 'Nummernkreise' },
    { number: 5, label: 'Fertig' }
];

const WizardStepper = ({ currentStep, stepsCompleted, onStepClick }) => {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.5rem 1rem',
            gap: '0'
        }}>
            {steps.map((step, index) => {
                const isCompleted = stepsCompleted[step.number];
                const isActive = currentStep === step.number;
                const canClick = isCompleted || step.number <= currentStep;

                return (
                    <React.Fragment key={step.number}>
                        {/* Step circle + label */}
                        <div
                            onClick={() => canClick && onStepClick(step.number)}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                cursor: canClick ? 'pointer' : 'default',
                                opacity: !canClick && !isActive ? 0.5 : 1,
                                transition: 'opacity 0.2s ease'
                            }}
                        >
                            <div style={{
                                width: '44px',
                                height: '44px',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '1rem',
                                fontWeight: '600',
                                transition: 'all 0.3s ease',
                                ...(isCompleted ? {
                                    background: 'var(--accent-slate, #5b7c8d)',
                                    color: '#ffffff',
                                    border: '2px solid var(--accent-slate, #5b7c8d)'
                                } : isActive ? {
                                    background: 'var(--accent-slate, #5b7c8d)',
                                    color: '#ffffff',
                                    border: '2px solid var(--accent-slate, #5b7c8d)',
                                    boxShadow: '0 0 0 4px rgba(91, 124, 141, 0.2)'
                                } : {
                                    background: 'var(--bg-card, #ffffff)',
                                    color: 'var(--text-secondary, #64748b)',
                                    border: '2px solid var(--border-medium, #cbd5e1)'
                                })
                            }}>
                                {isCompleted ? <Check size={20} /> : step.number}
                            </div>
                            <span style={{
                                marginTop: '0.5rem',
                                fontSize: '0.75rem',
                                fontWeight: isActive ? '600' : '500',
                                color: isActive || isCompleted
                                    ? 'var(--text-primary, #2c3e50)'
                                    : 'var(--text-secondary, #64748b)',
                                whiteSpace: 'nowrap'
                            }}>
                                {step.label}
                            </span>
                        </div>

                        {/* Connecting line */}
                        {index < steps.length - 1 && (
                            <div style={{
                                flex: '1',
                                height: '2px',
                                maxWidth: '120px',
                                minWidth: '40px',
                                marginTop: '-1.25rem',
                                background: stepsCompleted[step.number]
                                    ? 'var(--accent-slate, #5b7c8d)'
                                    : 'var(--border-medium, #cbd5e1)',
                                transition: 'background 0.3s ease'
                            }} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default WizardStepper;
